import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-invitation__out" }
const _hoisted_2 = {
  ref: "container",
  class: "p-invitation"
}
const _hoisted_3 = { class: "p-invitation__btn-group m_gap16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "p-invitation__title" }, " Пригласить друга ", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "p-invitation__txt a-font__l" }, " Выбери один из вариантов для приглашения: ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BaseButton, {
          class: "m_w311 mm_w100p m_font-big",
          onClick: _ctx.invitePage
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Онлайн-анкета ")
          ])),
          _: 1,
          __: [0]
        }, 8, ["onClick"]),
        _createVNode(_component_BaseButton, {
          class: "m_w311 mm_w100p m_font-big plc_ref-link",
          variant: "contrast",
          onClick: _ctx.copyLink
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Моя реферальная ссылка ")
          ])),
          _: 1,
          __: [1]
        }, 8, ["onClick"])
      ])
    ], 512),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "p-invitation__decoration" }, null, -1))
  ]))
}